/* em-generators.js — the seven generator product pages, built out.

   Sara, in her review (13:14): the generator pages on the current site are
   more built out than the normal product pages - where to put it, the
   accessories - and she wants a format for them that keeps that.
   Sept 9: each record may carry video: { youtube: 'id' } or { vimeo: 'id' } or
   { src: '/assets/video/x.mp4' }, with optional poster and caption. Sara is
   filming one per device; none is in yet, and the product page shows the
   slot with "Video coming" until it is.

   Everything here is lifted from energymuse.com/products/{slug} on 2026-09-07:
   their title, their three words, their preview paragraph and its points,
   their "Why", "Benefits You Can Feel" and "Where to Place It" sections.
   Trimmed for length by choosing sentences, never by rewriting them. The
   geometry lines are their product copy. The device facts in DEVICE are their
   instruction card, photographed on the 7.83 page; the 528 reviews confirm
   the same card ships with the others.

   The three-pack and five-pack are their real variants at their prices.
   Photos are their own gallery, four per generator, at 1200px.

   Loaded by /product/ only - nothing else needs 9KB of prose. Keyed by hz,
   matching EM_FREQ. */
window.EM_GEN = {
 "7.83": {
  "title": "7.83Hz Frequency Generator for Better Sleep",
  "three": [
   "Grounding",
   "Nervous System Reset",
   "Deep Calm"
  ],
  "intro": "The 7.83Hz Frequency Generator is a portable device that helps your body slow down and your mind let go so you can actually rest. It syncs with the Earth’s natural rhythm to relax your nervous system, ease restlessness, and bring you back to a steady, grounded state. Like taking a long exhale after a noisy day, it guides you toward calm nights and smoother mornings.",
  "points": [
   "Fall asleep faster",
   "Sleep Deeper",
   "Reset your nervous system",
   "Grounded, deep calm"
  ],
  "why": [
   "7.83Hz is Earth’s baseline frequency⁠—the natural rhythm every living system evolved with. It’s the energetic “home” your body is wired for, but modern life (screens, stress, EMFs) constantly pulls you away from it.",
   "By reintroducing this frequency into your environment, you support:",
   [
    "Deeper, more restorative sleep",
    "A calmer, more regulated nervous system",
    "A steady, grounded state you can actually feel"
   ]
  ],
  "benefits": [
   [
    "Better sleep from night one",
    "Fall asleep easier and stay asleep longer."
   ],
   [
    "Full-body grounding",
    "Feel more present, steady, and in your body."
   ],
   [
    "Nervous system reset",
    "Support vagus nerve activation and “rest-and-digest” states."
   ],
   [
    "Emotional balance",
    "Less frazzled, more centered, even on busy days."
   ],
   [
    "Energetic protection",
    "Create a coherent, stable field in the middle of modern tech and EMFs."
   ]
  ],
  "place": [
   [
    "On your nightstand or under your bed",
    ""
   ],
   [
    "In kids’ rooms or by pet beds for soothing, gentle support",
    ""
   ],
   [
    "Near your Wi-Fi router and electronics",
    ""
   ],
   [
    "In spaces where you rest, meditate, or create",
    ""
   ]
  ],
  "detail": [
   "Plate",
   "An engraved plate you can use as a broadcasting surface: place intentions, crystals, or water on it to infuse them with the Earth frequency in 33 minutes."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "ring": "7-83hz-frequency-ring-for-nervous-system-res",
  "formulas": [
   "formula-sleep"
  ],
  "photos": [
   "7-83-2.webp",
   "7-83-3.webp",
   "7-83-4.webp",
   "7-83-5.webp"
  ],
  "url": "https://energymuse.com/products/7-83-hz-earth-frequency-generator"
 },
 "174": {
  "title": "174Hz Frequency Generator for Tension & Stress Release",
  "three": [
   "Pain Relief",
   "Comfort",
   "Restoration"
  ],
  "intro": "The 174Hz Frequency Generator helps your body let go of tension — the tight shoulders, heavy chest, and stress that never fully leaves. It supports your nervous system so you can finally relax and feel safe and at ease in your own body. Think of it as deep comfort for both physical and emotional strain, gently restoring relief from the inside out.",
  "points": [
   "Releases physical and emotional tension",
   "Soothes mental stress and burnout",
   "Restores a sense of safety and ease",
   "Supports natural pain relief and comfort"
  ],
  "why": [
   "174Hz is the Root Frequency for your body’s comfort and safety. It works like an energetic exhale, helping your system release built-up tension and come back to a softer, more supported state.",
   "Instead of using sound or light, this device emits a silent 174Hz frequency field that gently meets your body where it hurts⁠—physically and emotionally⁠—so you can unwind from the inside out."
  ],
  "benefits": [
   [
    "Releases built-up tension",
    "Helps unwind tight muscles, clenched areas, and lingering stress in the body."
   ],
   [
    "Supports nervous system calm",
    "Encourages your system out of fight-or-flight and into “safe to relax” mode."
   ],
   [
    "Deep comfort & restoration",
    "Offers soothing support for both physical discomfort and emotional strain."
   ],
   [
    "Grounded, safer-in-your-body feeling",
    "Helps you feel more at home, present, and steady in your own skin."
   ],
   [
    "Enhances other healing practices",
    "Creates a softer, more receptive state for bodywork, energy work, or rest."
   ]
  ],
  "place": [
   [
    "On the body",
    "For targeted areas of discomfort or tightness"
   ],
   [
    "Bedroom",
    "For deeper relaxation before sleep or upon waking"
   ],
   [
    "Workspace",
    "To soften stress in your shoulders, neck, and jaw while you work"
   ],
   [
    "Healing or meditation space",
    "To create a field of comfort and safety"
   ],
   [
    "Anywhere you decompress",
    "The couch, reading chair, or your favorite corner to unwind"
   ]
  ],
  "detail": [
   "Geometry",
   "The Vector of Equilibrium, the sacred geometric symbol of perfect symmetry, universal stillness, and quantum recalibration."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ]
  ],
  "ring": "174hz-frequency-ring-for-tension-stress-reli",
  "formulas": [],
  "photos": [
   "174-2.webp",
   "174-3.webp",
   "174-4.webp",
   "174-5.webp"
  ],
  "url": "https://energymuse.com/products/174hz-frequency-generator"
 },
 "417": {
  "title": "417Hz Frequency Generator for Energy Clearing",
  "three": [
   "Removes Negativity",
   "Emotional Reset",
   "Renewal"
  ],
  "intro": "The 417Hz Frequency Generator clears built‑up stress and heaviness from your space, your body, and your mind. It sweeps away stale, heavy energy so everything feels lighter, clearer, and easier to move through. You can run this frequency 24/7 as a constant energetic reset⁠—quietly clearing the background “static” of your day so you rarely, if ever, feel the need to sage again.",
  "points": [
   "Clears heavy, stagnant energy from your space, body, and mind",
   "Creates a constant energetic reset⁠—so you rarely need to sage",
   "Supports emotional release and fresh starts after stress or long days",
   "Energy Muse–exclusive copper design with Seed of Life sacred geometry"
  ],
  "why": [
   "417Hz is the Energy Clearing Frequency⁠—a field for emotional reset, release, and fresh starts. It works like a daily reset button, gently dissolving what you’ve picked up from people, places, and screens, so your environment feels lighter and your body less weighed down."
  ],
  "benefits": [
   [
    "Clears heavy, stagnant energy",
    "Gently lifts the emotional “heaviness” in a room, making everything feel more open and breathable."
   ],
   [
    "Emotional reset after long or stressful days",
    "Helps you unwind from stress, conflict, or overexposure to other people’s moods and energy."
   ],
   [
    "Releases old stories, shame, and fear",
    "Supports letting go of patterns and programming that keep you stuck in the past."
   ],
   [
    "Refreshes your body and mind",
    "Helps your field feel cleaner and less congested so you can move, think, and feel more freely."
   ],
   [
    "Keeps working so you rarely need to sage",
    "Runs quietly in the background, providing ongoing clearing⁠—so you don’t have to constantly manage the energy of your space."
   ]
  ],
  "place": [
   [
    "Living room",
    "To reset family, guest, and day-to-day emotional buildup"
   ],
   [
    "Entryway",
    "To clear energy as it enters your home"
   ],
   [
    "Workspace or office",
    "To clear stress, pressure, and mental/emotional residue from work"
   ],
   [
    "Hallways or central areas",
    "To keep the energy moving and refreshed through the whole home"
   ],
   [
    "Any room that “never quite feels clear”",
    "Corners, dens, or rooms that hold old stories or memories"
   ]
  ],
  "detail": [
   "Geometry",
   "The Seed of Life, a sacred geometry symbol of renewal and new beginnings."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "ring": "417hz-frequency-ring-for-energy-clearing",
  "formulas": [
   "formula-home",
   "formula-sleep"
  ],
  "photos": [
   "417-2.webp",
   "417-3.webp",
   "417-4.webp",
   "417-5.webp"
  ],
  "url": "https://energymuse.com/products/417hz-frequency-generator"
 },
 "432": {
  "title": "432Hz Frequency Generator for Miracles & Blessings",
  "three": [
   "Harmony",
   "Alignment",
   "Natural Flow"
  ],
  "intro": "432Hz is known as the frequency of the universe, the frequency of harmony, alignment, and natural flow. Many believe that when you’re in harmony with the universe, life begins to shift: synchronicities appear, doors open, and blessings find their way to you.",
  "points": [
   "Raises the overall frequency and energy of your home",
   "Invites a peaceful, loving, harmonious atmosphere",
   "Helps you stay present to the small miracles around you every day",
   "Supports your spiritual practice, prayer, and connection to your angels",
   "Makes a meaningful gift: a blessing that works in someone’s home every day"
  ],
  "why": [
   "Heather created this generator because it’s the energy we all need right now. It’s a powerful reminder that miracles aren’t rare. They’re waiting for us to be ready to receive them.",
   "Placed in your home, the 432Hz Generator is designed to:",
   [
    "Attract miracles and blessings into every area of your life",
    "Raise the frequency of your home and everyone in it",
    "Invite you into flow with the universe, where things can shift quickly",
    "Open your heart to love, gratitude, and connection",
    "Strengthen your connection to your angels and divine guidance",
    "Soften tension and invite peace and calm into your space"
   ],
   "The 432Hz Generator works silently. There’s no sound and no music, just a steady, constant 432Hz frequency signal, working in your space around the clock.",
   "Exclusive to Energy Muse, the gold coil is crowned with the Golden Ratio Fibonacci spiral, the sacred pattern found in seashells, sunflowers, and galaxies. It’s nature’s blueprint for growth, harmony, and divine order, chosen to amplify the energy of miracles and blessings.",
   "Deep violet, the color of spirit. Radiant gold, the color of blessings."
  ],
  "benefits": [],
  "place": [
   [
    "Living room or center of your home",
    "to bless the whole household"
   ],
   [
    "Bedroom or nightstand",
    "to wake up and fall asleep in peace and gratitude"
   ],
   [
    "Front entryway",
    "to welcome blessings and miracles through your door"
   ],
   [
    "Meditation or prayer space",
    "to deepen your spiritual practice"
   ],
   [
    "Holiday table or gathering space",
    "to fill your celebrations with harmony and love"
   ]
  ],
  "detail": null,
  "url": "https://energymuse.com/products/432hz-frequency-generator"
 },
 "528": {
  "title": "528Hz Frequency Generator for Accelerated Manifestation",
  "three": [
   "Joy",
   "Magnetism",
   "Heart-Opening"
  ],
  "intro": "The portable 528Hz Frequency Generator lifts your energy into a brighter, more radiant state that speeds up manifestation, boosts confidence, and puts you in the flow. It helps you shift out of scarcity and into expansion⁠—making it easier to attract more of what you want. Think of it as a quiet heart-opener that brightens your mood and your outlook, reminding you that feeling good helps more good things find you.",
  "points": [
   "Speeds up manifestation",
   "Increases joy and optimism",
   "Boosts confidence and magnetism",
   "Gently opens and softens the heart"
  ],
  "why": [
   "528Hz is often called the Love Frequency⁠—a vibration linked with renewal, creativity, and expansion. When you’re attuned to this frequency, you’re more likely to:",
   [
    "Feel hopeful and motivated",
    "Take aligned action on your ideas",
    "Notice synchronicities and opportunities more easily"
   ],
   "Instead of forcing or pushing, you shift into a state where what you’re calling in can meet you faster."
  ],
  "benefits": [
   [
    "Accelerated Manifestation",
    "Experience a clearer path to attracting your desires and intentions."
   ],
   [
    "Uplifted Mood & Outlook",
    "Feel a natural boost in joy, optimism, and overall well-being."
   ],
   [
    "Increased Confidence",
    "Step into your power with greater self-assurance and magnetism."
   ],
   [
    "Heart-Centered Connection",
    "Open to deeper compassion, self-love, and harmonious relationships."
   ],
   [
    "Creative Flow",
    "Tap into inspired ideas and effortless productivity."
   ]
  ],
  "place": [
   [
    "Office",
    ""
   ],
   [
    "Creative studio",
    ""
   ],
   [
    "Kitchen",
    ""
   ],
   [
    "Bathroom or self-care space",
    ""
   ],
   [
    "Any area dedicated to visioning, journaling, or manifestation",
    ""
   ]
  ],
  "detail": null,
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "formulas": [
   "formula-sleep"
  ],
  "photos": [
   "528-2.webp",
   "528-3.webp",
   "528-4.webp"
  ],
  "url": "https://energymuse.com/products/528hz-frequency-generator"
 },
 "639": {
  "title": "639Hz Frequency Generator for Emotional Balance",
  "three": [
   "Connection",
   "Harmony",
   "Relationship Healing"
  ],
  "intro": "The 639Hz Frequency Generator dissolves internal friction and harmonizes the energy between you and your world. It smooths out emotional reactivity and \"static,\" creating a personal space that feels aligned, empathetic, and peaceful. Run this frequency 24/7 as a constant recalibration for your heart⁠—quietly bridging gaps in your relationships and within yourself so you can move with grace.",
  "points": [
   "Dissolves emotional friction and reactivity within your space, body, and mind",
   "Creates a constant harmonic reset⁠—fostering empathy and open-hearted connection",
   "Supports relationship healing and internal balance after stressful interactions"
  ],
  "why": [
   "639Hz is the Frequency of Connection⁠—a field for emotional integration, harmony, and relationship healing. It works like a gentle bridge, recalibrating the vibrations between your head and your heart, and between you and the people who matter most, so your environment supports love rather than the stress you’ve been managing."
  ],
  "benefits": [
   [
    "Smooths emotional reactivity",
    "Gently calms the \"spikes\" in your mood and the moods of those around you, making the atmosphere feel more stable."
   ],
   [
    "Strengthens your internal center",
    "Helps you feel more \"at home\" in your own skin, reducing the feeling of being easily triggered or drained."
   ],
   [
    "Heals relationship tension",
    "Softens the energy in shared spaces, encouraging empathy and helping to dissolve long-standing friction."
   ],
   [
    "Restores heart balance",
    "Supports the release of guardedness and old emotional stories, allowing you to lead with an open heart."
   ],
   [
    "Aligns your field with harmony",
    "Runs quietly in the background to keep your personal energy and your home’s energy in a state of flow and connection."
   ]
  ],
  "place": [
   [
    "Living Room",
    "To create a warm, inviting atmosphere for family, guests, and shared connection."
   ],
   [
    "Dining Area",
    "To ensure meal times and daily rituals are centered in harmony and presence."
   ],
   [
    "Shared Family Spaces",
    "To reduce friction in high-traffic areas where different moods and energies often collide."
   ],
   [
    "Bedroom",
    "To soften the heart before sleep and foster a deep sense of internal safety and unity with a partner."
   ],
   [
    "Any space where you connect",
    "Offices, dens, or creative rooms where you want to feel more aligned with your purpose and the world."
   ]
  ],
  "detail": [
   "Geometry",
   "A gold coil with the Merkaba symbol, the divine 3-6-9 geometry of universal energy flow."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "ring": "639hz-frequency-ring",
  "formulas": [
   "formula-home"
  ],
  "photos": [
   "639-2.webp",
   "639-3.webp",
   "639-4.webp"
  ],
  "url": "https://energymuse.com/products/639hz-frequency-generator"
 },
 "963": {
  "title": "963Hz Frequency Generator for Mental Focus",
  "three": [
   "Connection",
   "Awareness",
   "Clarity"
  ],
  "intro": "The 963Hz Frequency Generator clears the mental fog and self‑doubt that cloud your thinking and reconnects you to your inner guidance. It helps your mind slow down enough for ideas and insight to come through naturally. The result is quiet confidence⁠—calm focus, easier decisions, and a clear sense of what matters most.",
  "points": [
   "Clears mental fog and overthinking",
   "Calms self-doubt so decisions feel easier",
   "Supports focused work, study, and creativity",
   "Strengthens connection to your inner guidance"
  ],
  "why": [
   "963Hz is the frequency of higher clarity and inner knowing. Instead of taking you “out of your body,” it helps clear the noise⁠—overthinking, worry, mental loops⁠—so you can hear your own guidance again.",
   "This device emits a silent 963Hz frequency field (no sound or apps required) that supports both mental focus and intuitive connection⁠—so your logical mind and inner wisdom can work together, not against each other."
  ],
  "benefits": [
   [
    "Clears mental fog",
    "Helps your mind feel sharper, lighter, and more awake."
   ],
   [
    "Quiets self-doubt",
    "Softens second-guessing so you can trust your read on things."
   ],
   [
    "Sharper focus & decisions",
    "Supports calm concentration and more confident, aligned choices."
   ],
   [
    "Stronger inner guidance",
    "Helps you tune into your own “yes/no” without all the noise."
   ],
   [
    "Support for deep work & creativity",
    "Creates a clear mental field for writing, planning, and problem-solving."
   ]
  ],
  "place": [
   [
    "Office or desk",
    "To support focus, strategy, and decision-making"
   ],
   [
    "Study nook",
    "For reading, writing, and learning without distraction"
   ],
   [
    "Creative area",
    "To keep ideas flowing clearly and consistently"
   ],
   [
    "Meditation corner",
    "To deepen insight, journaling, and inner connection"
   ]
  ],
  "detail": [
   "Geometry",
   "The Torus symbol, etched into the coil."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "ring": "963hz-frequency-ring-for-mental-focus",
  "formulas": [
   "formula-home"
  ],
  "photos": [
   "963-2.webp",
   "963-3.webp",
   "963-4.webp",
   "963-5.webp"
  ],
  "url": "https://energymuse.com/products/963hz-frequency-generator"
 },
 "1111": {
  "title": "1111Hz Frequency Generator for Manifestation Mastery",
  "three": [
   "Breakthrough",
   "Attune",
   "Ignite"
  ],
  "intro": "When your nervous system is calm, manifestation happens faster. This is the frequency that quiets mental chaos, attracts synchronicity, and turns your biggest goals into inevitable momentum — without the struggle. Activated by the Vesica Pisces⁠—the sacred geometric symbol of where your intentions and actions merge, representing the exact moment your dreams become reality.",
  "points": [
   "Dissolves subconscious blocks",
   "Accelerates synchronicity to attract lucky breaks",
   "Bridges the dream-to-doing gap for massive momentum"
  ],
  "why": [
   "1111Hz is often called the Manifestation Mastery Frequency⁠—the sacred portal where intention meets reality. As the first generator in the Energy Muse collection to exceed 1000Hz, this frequency represents something higher: a quantum leap in manifestation power."
  ],
  "benefits": [
   [
    "Dissolving subconscious blocks",
    "The mental static and “white noise” that keeps you stuck fades away, leaving crystal-clear focus"
   ],
   [
    "Accelerated synchronicity",
    "Lucky breaks, aligned opportunities, and “right place, right time” moments become your new normal"
   ],
   [
    "Nervous system regulation",
    "Your body shifts out of fight-or-flight reactivity into calm, grounded certainty⁠—the state where manifestation accelerates"
   ],
   [
    "Bridging vision to action",
    "The paralyzing gap between dreaming and doing disappears, replaced by unstoppable momentum"
   ]
  ],
  "place": [
   [
    "Your workspace or office",
    ""
   ],
   [
    "Your visioning or journaling area",
    ""
   ],
   [
    "Your bedroom nightstand",
    ""
   ],
   [
    "Your creative studio",
    ""
   ],
   [
    "Your meditation or self-care space",
    ""
   ],
   [
    "High-pressure environments",
    ""
   ]
  ],
  "tip": "Move it throughout your day. Start with morning intention-setting in your bedroom, bring it to your workspace for focused action, then return it to your bedside to integrate the day’s manifestations overnight.",
  "detail": [
   "Geometry",
   "The Vesica Pisces, the sacred geometric symbol of where your intentions and actions merge."
  ],
  "packs": [
   [
    3,
    249.88,
    15
   ],
   [
    5,
    399.88,
    20
   ]
  ],
  "formulas": [],
  "photos": [
   "1111-2.webp",
   "1111-3.webp",
   "1111-4.webp",
   "1111-5.webp"
  ],
  "url": "https://energymuse.com/products/1111hz-frequency-generator"
 },

 /* Sept 29 (Sara, in the findings sheet): "the specs and custom copy didn't get carried over like on
    the other 7 pages". The eighth generator. It was left out of EM_FREQ on purpose on Sept 23 -- it is
    a rotating sequence of three wealth codes, not one fixed tone, and the quiz and intention pages
    match on tone -- but the product page reads the same key, so excluding it from matching also
    excluded it from the built-out layout. One decision, two consequences, only one of them wanted.
    Keyed by handle rather than hz, because it has no single hz. Everything below is their copy from
    energymuse.com/products/the-wealth-codes-frequency-generator, trimmed by choosing sentences.
    There is no "where to place" section in their copy for this one, so place is empty rather than
    invented; the Pro tip is their own "Want more control?" line. */
 "the-wealth-codes-frequency-generator": {
  "title": "The Wealth Codes Frequency Generator",
  "three": [
   "Cosmic Flow",
   "Infinite Opportunity",
   "Lasting Wealth"
  ],
  "intro": "Imagine if someone took 40 years of energetic mastery and distilled it into a single device. That's the Wealth Codes Generator. We built it because it's what we wanted in our own office and home — and nothing like it existed. So we made it ourselves.",
  "points": [
   "Three of the most powerful wealth frequencies, built into a single rotating sequence",
   "Each one runs for 12 minutes before cycling to the next",
   "Choose which of the three codes starts the cycle"
  ],
  "whyTitle": "What Does It Mean to Code Your Space?",
  "why": [
   "A wealth code is a specific frequency tuned to one layer of financial energy that continuously codes your space to support it. A constant, running signal your space holds all day, every day.",
   "(We're not sharing the exact frequencies inside — that's part of what makes this secret yours to discover.)"
  ],
  "benefits": [
   [
    "Cosmic Flow",
    "supports the movement of new opportunity toward you"
   ],
   [
    "Infinite Opportunity & Abundance",
    "reinforces material gain and financial momentum"
   ],
   [
    "Lasting Wealth",
    "strengthens a sense of stability and financial ground that holds"
   ]
  ],
  "place": [],
  "tip": "Want more control? Choose which of the three codes starts the cycle — ideal before a negotiation, a big meeting, or any moment you want to lead with a specific focus.",
  "freq": "Three of the most powerful wealth frequencies, built into a single rotating sequence. Each one runs for 12 minutes before cycling to the next.",
  "setup": "Choose which of the three codes starts the cycle.",
  "formulas": [],
  "url": "https://energymuse.com/products/the-wealth-codes-frequency-generator"
 }
};
/* their instruction card, word for word where it can be */
window.EM_GEN_DEVICE = {
 "field": "Silent. No sound, no apps.",
 "range": "A radius of 308 sq. ft.",
 "power": "Built-in rechargeable lithium battery. On a full charge, the battery can last up to 7 days. It can be charged daily, used while charging, or charged after each use.",
 "light": "Steady red: the unit is charging. Steady green: the battery is fully charged. Blinking blue: active working mode. Off: powered off, or the battery is drained.",
 "switch": "Plugged in or on the go, the power switch must be in the ON position for it to emit frequency."
};
